import type {
  HonorJobApplicationRequest,
  HonorJobApplicationResponse,
} from "./types/honor-careers";

import { apiPost } from "@homeinstead/shared/outbound";
import {
  getMarketingApiConfig,
  MARKETING_API_KEY_HEADER,
} from "./get-marketing-api-config";

const HONOR_JOB_APPLICATIONS_PATH = "/api/v1/honor/job-applications";

async function postHonorJobApplication(
  body: HonorJobApplicationRequest,
): Promise<HonorJobApplicationResponse> {
  const { apiKey, url } = getMarketingApiConfig();

  return apiPost<HonorJobApplicationResponse>(
    `${url}${HONOR_JOB_APPLICATIONS_PATH}`,
    {
      body: JSON.stringify(body),
      headers: {
        [MARKETING_API_KEY_HEADER]: apiKey,
      },
    },
    {},
  );
}

export { postHonorJobApplication };
